<nav class="navbar navbar-light bg-light navbar-expand-lg ">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <!--Filtrar grupos-->
    <div class="form-inline me-2">
      <input id="busquedaFormControl" type="text" class="form-control" placeholder="Cliente"
        (input)="filtrarDatos($event.target.value)" />
    </div>
    <ul class="navbar-nav me-auto">
      <!--Nuevo Grupo-->
      <li class="nav-item float-end me-2">
        <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" (click)="nuevaConfiguracion()"> Nueva
          configuraci&oacute;n </button>
      </li>
    </ul>
  </div>
</nav>

<div class="row" [formGroup]="informacionContainer">
  <div class="col col-3">
    <div class="list-group py-3 menu-izq">
      <ng-container *ngIf="cargandoLista">
        <div class="col col-md-12">
          <div class="spinner-container">
            <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
              type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">C a r g a n d o . . . </p>
            </ngx-spinner>
          </div>
        </div>
      </ng-container>
      <!-- lista de clientes -->
      <div *ngIf="!cargandoLista">
        @for (clienteIata of datosFiltrados; track $index) {
        <button type="button" class="list-group-item list-group-item-action"
          (click)="usuarioSeleccionaDato(clienteIata)">
          <div class="d-flex w-100 justify-content-between">
            <p> {{ clienteIata.clienteSolicitante.razonSocial }} </p>
          </div>
        </button>
        }
      </div>
    </div>
  </div>
  <!-- informacion de las cuentas del cliente -->
  @if (clienteSeleccionado === true){
  <div class="col col-9 py-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center mb-0"> {{ datoSeleccionado.clienteSolicitante.razonSocial }}</h5>
      </div>
      <div class="modal-body">
        @if (!datoSeleccionado.configuracion.length > 0){
        <ngb-alert type="warning" class="alert alert warning m-3">
          No existen configuraciones de cuentas para mostrar
        </ngb-alert>
        } @else {
        <!--PANEL DESPLEGABLE-->
          <div id="contenedorcuentas" class="accordion accordion-flush" *ngIf="datoSeleccionado.configuracion?.length > 0"
               formArrayName="listaCuentasFormControlArray">
            <div class="accordion-item" *ngFor="let cuen of listaCuentasFormControlArray.controls; let index = index">
              <div [formGroupName]="index">
                <h2 class="accordion-header d-flex align-items-center justify-content-between">
                  <!-- Contenido del encabezado -->
                  <button class="accordion-button collapsed flex-grow-1" type="button" data-bs-toggle="collapse"
                          [attr.data-bs-target]="'#flush-collapseOne' + index" aria-expanded="false"
                          [attr.aria-controls]="'flush-collapseOne' + index" style="border-radius: 5px;" [ngClass]="{
            'lightblue': cuen.value.tipoCuenta !== TipoCuenta.Contado && cuen.value.activo !== false,
            'lightyellow': cuen.value.tipoCuenta === TipoCuenta.Contado,
            'lightgray': cuen.value.activo === false
          }">
                    <button type="button" (click)="eliminarCuenta(index)" ngbTooltip="Eliminar cuenta" 
                            class="btn btn-danger position-absolute start-0 ms-1" style="flex-shrink: 0;">
                          <i class="fa fa-trash"></i>
                    </button>
                    <div class="text-center w-100">
                        Cuenta: {{ cuen.value.cuentaSolicitante.descripcion }} - {{ cuen.value.clienteImputar.razonSocial }}
                    </div>
                  </button>
                </h2>

                <div [id]="'flush-collapseOne' + index" class="accordion-collapse collapse"
                     data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <app-iata-cuentas-detalle [aeroplantasLista]="aeroplantasLista" [agregarCuenta]="false" [editarCuenta]="true" [clienteNuevo]="false"
                                              [clientesCuenta]=clientes [index]="index"></app-iata-cuentas-detalle>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
      <!--PANEL NUEVA CUENTA-->
      <div class="panel panel-default">
        <div class="panel-heading bg-primary justify-content-center" style="display: flex;" (click)="agregarCuenta()">
          <h6 class="panel-title">
            + Agregar nueva cuenta
          </h6>
        </div>
      </div>
    </div>
  </div>
  } 
</div>
